import { useRealtime } from '@/lib/useRealtime';
import { cn } from '@/lib/utils';

export function LiveIndicator() {
  const { status } = useRealtime(() => {
    /* root-level subscriber; page components attach their own handlers */
  });

  const colour =
    status === 'connected'
      ? 'bg-success'
      : status === 'connecting' || status === 'reconnecting'
        ? 'bg-warning'
        : 'bg-destructive';

  return (
    <div
      className="flex size-10 items-center justify-center"
      aria-label={`Realtime: ${status}`}
      title={`Realtime: ${status}`}
    >
      <span className="relative flex size-2">
        <span className={cn('pulse-dot absolute inline-flex size-full rounded-full', colour)} />
        <span className={cn('relative inline-flex size-2 rounded-full', colour)} />
      </span>
    </div>
  );
}
